// Access Token işlemleri
export const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};

export const setAuthToken = (token: string): void => {
  localStorage.setItem('token', token);
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('token');
};

// Refresh Token işlemleri
export const getRefreshToken = (): string | null => {
  return localStorage.getItem('refreshToken');
};

export const setRefreshToken = (token: string): void => {
  localStorage.setItem('refreshToken', token);
};

export const removeRefreshToken = (): void => {
  localStorage.removeItem('refreshToken');
};

// Token süresini kaydet
export const setTokenExpiry = (expiresIn: string): void => {
  // expiresIn: "1h", "24h", "7d" gibi formatlar
  const now = Date.now();
  let expiryMs = 0;

  if (expiresIn.endsWith('h')) {
    expiryMs = parseInt(expiresIn) * 60 * 60 * 1000;
  } else if (expiresIn.endsWith('d')) {
    expiryMs = parseInt(expiresIn) * 24 * 60 * 60 * 1000;
  } else if (expiresIn.endsWith('m')) {
    expiryMs = parseInt(expiresIn) * 60 * 1000;
  }

  const expiryTime = now + expiryMs;
  localStorage.setItem('tokenExpiry', expiryTime.toString());
};

export const getTokenExpiry = (): number | null => {
  const expiry = localStorage.getItem('tokenExpiry');
  return expiry ? parseInt(expiry) : null;
};

// Token'ın süresi dolmuş mu kontrol et (5 dakika buffer ile)
export const isTokenExpired = (): boolean => {
  const expiry = getTokenExpiry();
  if (!expiry) return true;

  const buffer = 5 * 60 * 1000; // 5 dakika önce yenile
  return Date.now() > (expiry - buffer);
};

// Tüm auth verilerini temizle
export const clearAuthData = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('user');
};

// Kullanıcının login durumunu kontrol et
export const isAuthenticated = (): boolean => {
  const token = getAuthToken();
  const refreshToken = getRefreshToken();
  return !!(token || refreshToken);
};

// Login sonrası tüm token'ları kaydet
export const saveAuthTokens = (data: {
  token: string;
  refreshToken?: string;
  expiresIn?: string;
}): void => {
  setAuthToken(data.token);
  if (data.refreshToken) {
    setRefreshToken(data.refreshToken);
  }
  if (data.expiresIn) {
    setTokenExpiry(data.expiresIn);
  }
};
